var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDashboardRefreshWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none",
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M16.952 6.757c-1.321-1.267-3.078-1.965-4.946-1.965a7.133 7.133 0 0 0-4.553 1.617L6.097 5.13l-.272 4.416 4.684-.332-1.33-1.18a4.69 4.69 0 0 1 2.827-.934c2.53 0 4.587 1.973 4.587 4.4 0 2.425-2.057 4.399-4.587 4.399a4.68 4.68 0 0 1-3.119-1.175 4.317 4.317 0 0 1-1.452-2.873l-.03-.362H5l.026.417c.22 3.533 3.287 6.301 6.98 6.301 1.868 0 3.625-.697 4.946-1.964C18.272 14.977 19 13.292 19 11.5c0-1.792-.727-3.476-2.048-4.743z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDashboardRefreshWhite);
export default __webpack_public_path__ + "static/media/Icons_Dashboard_Refresh_White.f2f1058c4f56d482de86574f52bc1017.svg";
export { ForwardRef as ReactComponent };